import { PermissionT } from "../types";

export const teamView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "team_view");
  return !!p;
};

export default teamView;
